module.exports = { "default": require("core-js/library/fn/math/asinh"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/asinh.js
// module id = 1396
// module chunks = 2